(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var popup = document.querySelector('.promo-popup');
    if (!popup) return;
    setTimeout(function() {
      popup.classList.add('promo-popup--visible');
    }, 800);

    var closeBtn = popup.querySelector('.promo-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        popup.classList.remove('promo-popup--visible');
        popup.classList.add('promo-popup--hidden');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
